import {
  tipoAcidentesList,
  jurisdicaoList,
  simNaoNaoInformado,
  severidade,
  elementosAtingidosList,
  viaOuCruzamentoList,
  iluminacaoList,
  tempoList,
  localList,
  superficiePistaList,
  tipoCruzamento,
  controleTrafegoList,
  sinalizacaoHorizontalList,
  alinhamentoHorizontalList,
  alinhamentoVerticalList,
  obraDeArteList,
  tipoPistaList,
  obrasNaPistaList,
  tipoPavimentoList,
  faixaSentidoList,
  condicaoPistaList,
  separacaoCentralList,
  veiculosList,
  especieList,
  categoriaList,
  danificadoList,
  aluguelList,
  sexoList,
  categoriaCondutorList,
  exameAlcolemiaList,
  situacaoCondutorList,
  encaminhamentoList,
  posicaoPassageiroList,
  evolucaoCasoList,
  tipoPessoaList,
  lesoesList,
  gravidadeLesaoList,
  condicaoCalcadaList,
  bairrosList,
  informacaoFontesList,
  sinalizacaoVerticalList,
  perfilUsuarioList,
  tipoDocumentoList,
} from '../../utils/objectsSelect';
import { RecordType } from '../../@types/records';
import { IncidentResponse } from '../../@types/incidentTypes';

export interface FormEntriesType {
  label: string;
  type: string;
  options?: Array<{ label: string }>;
}

export const viaEntries: FormEntriesType[] = [
  { label: 'Nome', type: 'text' },
  { label: 'Sinalização Horizontal', type: 'select', options: sinalizacaoHorizontalList },
  { label: 'Sinalização Vertical', type: 'select', options: sinalizacaoHorizontalList },
  { label: 'Alinhamento Horizontal', type: 'select', options: alinhamentoHorizontalList },
  { label: 'Alinhamento Vertical', type: 'select', options: alinhamentoVerticalList },
  { label: 'Obra de Arte', type: 'select', options: obraDeArteList },
  { label: 'Obras na Pista', type: 'select', options: obrasNaPistaList },
  { label: 'Tipo da Pista', type: 'select', options: tipoPistaList },
  { label: 'Tipo do Pavimento', type: 'select', options: tipoPavimentoList },
  { label: 'Faixa para Sentido', type: 'select', options: faixaSentidoList },
  { label: 'Condição da Pista', type: 'select', options: condicaoPistaList },
  { label: 'Condição da Calçada', type: 'select', options: condicaoCalcadaList },
  { label: 'Separação Central', type: 'select', options: separacaoCentralList },
];

export const incidentDetailsEntries: FormEntriesType[] = [
  { label: 'Natureza', type: 'select', options: tipoAcidentesList },
  { label: 'Jurisdição', type: 'radio', options: jurisdicaoList },
  { label: 'Interseção', type: 'radio', options: simNaoNaoInformado },
  { label: 'Severidade', type: 'radio', options: severidade },
  { label: 'Elementos Atingidas', type: 'select', options: elementosAtingidosList },
  {
    label: 'Ocorrido ao Longo da Via/Cruzamento',
    type: 'radio',
    options: viaOuCruzamentoList,
  },
  { label: 'Primeira Fonte de Informação', type: 'text' },
  { label: 'Código do Acidente', type: 'text' },
  { label: 'Hora informada', type: 'radio', options: simNaoNaoInformado },
  { label: 'Iluminação', type: 'select', options: iluminacaoList },
  { label: 'Tempo', type: 'radio', options: tempoList },
  { label: 'Local', type: 'select', options: localList },
  { label: 'Superfície da Pista', type: 'select', options: superficiePistaList },
  { label: 'Tipo de Cruzamento', type: 'select', options: tipoCruzamento },
  { label: 'Controle de Tráfego', type: 'select', options: controleTrafegoList },
  { label: 'Código AMC', type: 'text' },
  { label: 'Código SAMU', type: 'text' },
  { label: 'Código PRF', type: 'text' },
  { label: 'Código PRE', type: 'text' },
  { label: 'Código PEFORCE', type: 'text' },
  { label: 'Código SIM', type: 'text' },
];

export const envolvidosEntries: FormEntriesType[] = [
  { label: 'Nome', type: 'text' },
  { label: 'Sexo', type: 'radio', options: sexoList },
  { label: 'Idade', type: 'text' },
  { label: 'Número da CNH', type: 'text' },
  { label: 'Usava Cinto ou Capacete', type: 'radio', options: simNaoNaoInformado },
  { label: 'Data de Alta', type: 'text' },
  { label: 'Data de Internação', type: 'text' },
  { label: 'Categoria do Condutor', type: 'select', options: categoriaCondutorList },
  { label: 'Exame de alcoolemia', type: 'select', options: exameAlcolemiaList },
  { label: 'Dosagem', type: 'text' },
  { label: 'Situação do Condutor', type: 'select', options: situacaoCondutorList },
  { label: 'Encaminhamento', type: 'select', options: encaminhamentoList },
  { label: 'Posição do Passageiro', type: 'select', options: posicaoPassageiroList },
  { label: 'Evolução de Caso', type: 'select', options: evolucaoCasoList },
  { label: 'Tipo de Morte', type: 'text' },
  { label: 'Custo Geral', type: 'text' },
  { label: 'Número do cartão de saúde cidadão', type: 'text' },
  { label: 'Início de Reabilitação', type: 'text' },
  { label: 'Fim da Reabilitação', type: 'text' },
  { label: 'Data da Óbito', type: 'text' },
  { label: 'Observações', type: 'text' },
  { label: 'Procedimentos realizados', type: 'text' },
  { label: 'Tipo de Pessoa', type: 'select', options: tipoPessoaList },
  { label: 'Lesões', type: 'multicheck', options: lesoesList },
  { label: 'Código Veículo', type: 'text' },
  { label: 'Gravidade da Lesão', type: 'select', options: gravidadeLesaoList },
  { label: 'Número Documento', type: 'text' },
  { label: 'Tipo Documento', type: 'text' },
];

export const veiculosEntries: FormEntriesType[] = [
  { label: 'Tipo Veículo', type: 'select', options: veiculosList },
  { label: 'Placa', type: 'text' },
  { label: 'Marca', type: 'text' },
  { label: 'Número do Ônibus', type: 'text' },
  { label: 'Linha do Ônibus', type: 'text' },
  { label: 'Cor', type: 'text' },
  { label: 'Ano Fabricação', type: 'text' },
  { label: 'Espécie', type: 'select', options: especieList },
  { label: 'Categoria', type: 'select', options: categoriaList },
  { label: 'Legalizado', type: 'radio', options: simNaoNaoInformado },
  { label: 'Manobra', type: 'text' },
  { label: 'Outra Manobra', type: 'text' },
  { label: 'Danificado', type: 'radio', options: danificadoList },
  { label: 'Aluguel', type: 'select', options: aluguelList },
  { label: 'Código Veículo', type: 'text' },
];

export const initialRecord: RecordType = {
  archived: false,
  city: 'Fortaleza',
  city_district: '',
  county: 'Microrregião de Fortaleza',
  created: '2020-09-21T14:13:58.980185-03:00',
  data: {
    driverIncidenteDetails: {
      'Controle de Tráfego': 'Não informado',
      'Código AMC': '',
      'Código PEFOCE': '',
      'Código PRE': '',
      'Código SAMU': '',
      'Código PRF': '',
      'Código SIM': '',
      'Código do Acidente': '',
      'Elementos Atingidas': 'Não informado',
      'Endereço 1': 'Pista Marginal, Fortaleza - CE',
      'Endereço 2': 'Não infomado',
      'Hora informada': 'Não informado',
      Iluminação: 'Não informado',
      Interseção: 'Não informado',
      Jurisdição: 'Não informado',
      Local: 'Não informado',
      Natureza: 'Não informado',
      'Ocorrido ao Longo da Via/Cruzamento': 'Cruzamento',
      'Primeira Fonte de Informação': '',
      Severidade: 'Não informado',
      'Superfície da Pista': 'Não informado',
      Tempo: 'Não informado',
      'Tipo de Cruzamento': 'Não informado',
    },
    driverVeiculo: [],
    driverVia: [],
    driverVitima: [],
  },
  geom: '',
  light: null,
  location_text: 'Pista Marginal, Fortaleza - CE - Não infomado',
  modified: '2020-09-21T14:13:58.980207-03:00',
  modified_by: 'siat@siat.com',
  neighborhood: '',
  occurred_from: '2020-09-21T14:13:45.773000-03:00',
  occurred_to: '2020-09-21T14:13:45.773000-03:00',
  road: 'Pista Marginal',
  schema: `${process.env.REACT_APP_INCIDENT_SCHEMA_ID}`,
  state: 'CE',
  uuid: '8d31edf8-39ee-4049-91ea-31cec14038c2',
  weather: '',
  created_by: '',
};

const isInList = (option: string | undefined, list: { label: string }[]): string => {
  let index: { label: string } | undefined;
  if (typeof option !== 'undefined') {
    index = list.find((item) => item.label === option);
    return index ? option : 'Não informado';
  }
  return 'Não informado';
};

export const validadeObjectProps = (data: IncidentResponse): IncidentResponse => {
  const { driverIncidenteDetails } = data.data;
  driverIncidenteDetails.Jurisdição = isInList(
    driverIncidenteDetails.Jurisdição,
    jurisdicaoList,
  );
  driverIncidenteDetails.Natureza = isInList(
    driverIncidenteDetails.Natureza,
    tipoAcidentesList,
  );
  driverIncidenteDetails.Interseção = isInList(
    driverIncidenteDetails.Interseção,
    simNaoNaoInformado,
  );
  driverIncidenteDetails.Severidade = isInList(
    driverIncidenteDetails.Severidade,
    severidade,
  );
  driverIncidenteDetails['Elementos Atingidas'] = isInList(
    driverIncidenteDetails['Elementos Atingidas'],
    elementosAtingidosList,
  );
  driverIncidenteDetails['Primeira Fonte de Informação'] = isInList(
    driverIncidenteDetails['Primeira Fonte de Informação'],
    informacaoFontesList,
  );
  driverIncidenteDetails['Hora informada'] = isInList(
    driverIncidenteDetails['Hora informada'],
    simNaoNaoInformado,
  );
  driverIncidenteDetails.Iluminação = isInList(
    driverIncidenteDetails.Iluminação,
    iluminacaoList,
  );
  driverIncidenteDetails.Tempo = isInList(driverIncidenteDetails.Tempo, tempoList);
  driverIncidenteDetails.Local = isInList(driverIncidenteDetails.Local, localList);
  driverIncidenteDetails['Superfície da Pista'] = isInList(
    driverIncidenteDetails['Superfície da Pista'],
    superficiePistaList,
  );
  driverIncidenteDetails['Tipo de Cruzamento'] = isInList(
    driverIncidenteDetails['Tipo de Cruzamento'],
    tipoCruzamento,
  );
  driverIncidenteDetails['Controle de Tráfego'] = isInList(
    driverIncidenteDetails['Controle de Tráfego'],
    controleTrafegoList,
  );

  let { driverVeiculo } = data.data;
  driverVeiculo = driverVeiculo.map((item) => {
    item['Tipo Veículo'] = isInList(item['Tipo Veículo'], veiculosList)
    item.Espécie = isInList(item.Espécie, especieList);
    item.Categoria = isInList(item.Categoria, categoriaList);
    item.Aluguel = isInList(item.Aluguel, aluguelList);
    item.Legalizado = isInList(item.Legalizado, simNaoNaoInformado);
    item.Danificado = isInList(item.Danificado, danificadoList);
    item['Via de Acesso'] = item['Via de Acesso'] || 'Não informado';
    return item;
  });

  let { driverVia } = data.data;

  driverVia = driverVia.map((item) => {
    item['Sinalização Horizontal'] = isInList(
      item['Sinalização Horizontal'],
      sinalizacaoHorizontalList,
    );
    item['Sinalização Vertical'] = isInList(
      item['Sinalização Vertical'],
      sinalizacaoVerticalList,
    );
    item['Alinhamento Horizontal'] = isInList(
      item['Alinhamento Horizontal'],
      alinhamentoHorizontalList,
    );
    item['Alinhamento Vertical'] = isInList(
      item['Alinhamento Vertical'],
      alinhamentoVerticalList,
    );
    item['Obra de Arte'] = isInList(item['Obra de Arte'], obraDeArteList);
    item['Obras na Pista'] = isInList(item['Obras na Pista'], obrasNaPistaList);
    item['Tipo da Pista'] = isInList(item['Tipo da Pista'], tipoPistaList);
    item['Tipo do Pavimento'] = isInList(item['Tipo do Pavimento'], tipoPavimentoList);
    item['Faixa para Sentido'] = isInList(item['Faixa para Sentido'], faixaSentidoList);
    item['Condição da Calçada'] = isInList(
      item['Condição da Calçada'],
      condicaoCalcadaList,
    );
    item['Condição da Pista'] = isInList(item['Condição da Pista'], condicaoPistaList);
    item['Separação Central'] = isInList(item['Separação Central'], separacaoCentralList);

    return item;
  });

  let { driverVitima } = data.data;

  driverVitima = driverVitima.map((item) => {
    item['Perfil do Usuário'] = isInList(item['Perfil do Usuário'], perfilUsuarioList);
    item['Gravidade da Lesão'] = isInList(item['Gravidade da Lesão'], gravidadeLesaoList);
    item['Código Veículo'] = item['Código Veículo'] || 'Nenhum';
    item.Sexo = isInList(item.Sexo, sexoList);
    item['Categoria do Condutor'] = isInList(
      item['Categoria do Condutor'],
      categoriaCondutorList,
    );
    item['Tipo Documento'] = isInList(item['Tipo Documento'], tipoDocumentoList);
    item['Situação do Condutor'] = isInList(
      item['Situação do Condutor'],
      situacaoCondutorList,
    );
    item['Usava Cinto ou Capacete'] = isInList(
      item['Usava Cinto ou Capacete'],
      simNaoNaoInformado,
    );
    item['Posição do passageiro'] = isInList(
      item['Posição do passageiro'],
      posicaoPassageiroList,
    );
    item['Exame de alcoolemia'] = isInList(
      item['Exame de alcoolemia'],
      exameAlcolemiaList,
    );
    item.Encaminhamento = isInList(item.Encaminhamento, encaminhamentoList);
    item['Evolução de caso'] = isInList(item['Evolução de caso'], evolucaoCasoList);

    return item;
  });

  data.data.driverIncidenteDetails = { ...driverIncidenteDetails };
  data.data.driverVeiculo = [...driverVeiculo];
  data.data.driverVia = [...driverVia];
  data.data.driverVitima = [...driverVitima];
  return data;
};
